import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLaunch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M6.921 3.743a1.333 1.333 0 0 1 2 .029l.213.249a1.333 1.333 0 0 1-.07 1.81L6.937 7.958l-1.61 1.61c-.25.25-.588.39-.942.39h-.1c-1.158 0-1.766-1.373-.987-2.23l3.623-3.985Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M13.265 4.463a1.384 1.384 0 0 0-1.989 0l-7.17 7.314a1.49 1.49 0 0 0 0 2.072l4.328 4.414a5.373 5.373 0 0 0 7.674 0l4.327-4.414a1.49 1.49 0 0 0 0-2.072l-7.17-7.314Zm-3.06-1.05a2.884 2.884 0 0 1 4.132 0l7.169 7.314a2.99 2.99 0 0 1 0 4.172l-4.327 4.414a6.873 6.873 0 0 1-9.816 0L3.036 14.9a2.99 2.99 0 0 1 0-4.172l7.17-7.314Z"
    />
    <path
      fill="#F7A600"
      d="m10.27 15.292 1.312-6h1.983l-1.068 4.46h2.44l-.243 1.54H10.27Z"
    />
  </svg>
);
export default SvgTwoColorLaunch;
